module.exports = __webpack_public_path__ + "static/media/zoom_out_on.11172d04.svg";